import styled from "styled-components";

export const StyledChangeAmount = styled.span`
  padding: 2px 8px;
  color: ${({ positive, isZero, theme }) => isZero ? theme.badge.neutralColor : positive ? theme.badge.successColor : theme.badge.dangerColor};
  font-weight: 600;
  background-color: ${({ positive, isZero, theme }) => isZero ? theme.badge.neutralBackground : positive ? theme.badge.successBackground : theme.badge.dangerBackground};
  border-radius: 5px;
`;
